/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import ZoneCass from 'solis/logic/board/zone/cass';

import * as Array from 'fierry/util/array';
import * as Equation from 'solis/claude/util/equation/control';


export default class ZoneUserControl extends Logic
{
  constructor (zone, user)
  {
    super(zone);

    this.user = user;
  }


  getInfluence ()
  {
    return Array.sum(this.object.getInfluencesForUser(this.user), (influence) => influence.cass.value);
  }


  getControl (now)
  {
    if (now == null)
    {
      return new ZoneCass(this.object).getControl(this.user);
    }

    return Equation.getValue(this.getControl(), now - this.cass.updateDate, this._getUserConfig(), this._getGlobalConfig());
  }


  getControlRate (now)
  {
    return Equation.getControlRate(this.getControl(now), this._getUserConfig(), this._getGlobalConfig());
  }


  getEquilibrium (now)
  {
    return Equation.getEquilibriumValue(this.getControl(now), this._getUserConfig(), this._getGlobalConfig());
  }


  getCrossingDate (other, now)
  {
    const ticks = Equation.getTicksToEqual(this.getControl(now), other.getControl(now), this._getUserConfig(), other._getUserConfig(), this._getGlobalConfig());

    return ticks > 0 ? now + ticks + 1 : null;
  }


  getFlipDate (other, now)
  {
    if (other.getControl(now) >= this.getControl(now))
    {
      return null;
    }

    return this.getCrossingDate(other, now);
  }


  getStabilizeDate (now)
  {
    if (this.getEquilibrium(now) === 0)
    {
      return null;
    }

    const ticks = Equation.getTicksToEquilibrium(this.getControl(now), this._getUserConfig(), this._getGlobalConfig());

    return ticks > 0 ? now + ticks : null;
  }


  getFadeOutDate (now)
  {
    const value = this.getControl(now);

    if (value === 0 || this.getEquilibrium(now) !== 0)
    {
      return null;
    }

    return now + Equation.getTicks(value, 0, this._getUserConfig(), this._getGlobalConfig());
  }


  getLinearAttrition ()
  {
    if (this.cass.currentUser === this.user)
    {
      return 0;
    }

    return this.object.getBoard().getSettings().getControlLinAttrition();
  }


  getExponentialAttrition ()
  {
    return this.object.getBoard().getSettings().getControlExpAttrition();
  }


  _getUserConfig ()
  {
    return { influence: this.getInfluence(), linearAttrition: this.getLinearAttrition(), exponentialAttrition: this.getExponentialAttrition() };
  }


  _getGlobalConfig ()
  {
    const settings = this.object.getBoard().getSettings();

    return { threshold: settings.getZoneInitialControl(), roundDuration: settings.getRoundDuration() };
  }


};
